import React, {useEffect} from "react";

import bg from "../../assets/hero_section_bg_driver.webp";
import front from "../../assets/hero_section_front_driver_.webp";
import "../../Css/DriverPartnerLogin.css";

function DriverSection1() {

  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://packky.com/SeoBix/seo_injection.php?webid=cd8435ad15b4e27805d9e08fbaa8d536&url=${encodedUrl}&baseUrl=https%3A%2F%2Fpackky.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  
  return (
  <section className="hero-section relative flex min-h-screen flex-col items-center justify-center overflow-hidden">
    {/* Background */}
    <div className="image-section absolute left-0 top-0 -z-10 h-full w-full">
      <img
        src={bg}
        alt="glare"
        className="hero-img h-full w-full object-cover"
      />
      <div className="image-overlay absolute left-0 top-0 h-full w-full"></div>
    </div>

    {/* Foreground Content */}
    <div className="mx-auto w-full max-w-7xl px-3 py-10 sm:px-4 md:py-14">
      <div className="flex justify-center">
        <div className="w-full max-w-[1050px] sm:w-[90%] lg:w-[82%] xl:w-[75%]">
          <div
            className="mt-5 rounded-2xl p-4 shadow sm:p-5 md:p-8 lg:p-14"
            style={{
              background: "rgba(237, 241, 249, 0.7)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
            }}
          >
            <div className="grid grid-cols-1 items-center gap-6 md:grid-cols-12 md:gap-8 lg:gap-10">
              {/* Left Side */}
              <div className="col-span-12 md:col-span-7">
                <img
                  src={front}
                  alt="Delivery Van"
                  className="mb-3 h-[180px] w-full rounded-2xl object-cover sm:h-[220px] md:h-[270px]"
                />

                <h2
                  style={{ fontWeight: "400" }}
                  className="m-0 p-0 text-center font-sf text-[22px] leading-snug sm:text-[28px] md:text-left text-[#212529]"
                >
                  Earn money delivering goods and packages.
                </h2>
              </div>

              {/* Right Side - Form */}
              <div className="col-span-12 md:col-span-5">
                <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-4 shadow sm:p-5 md:max-w-none">
                  <h5 className="mb-4 text-center text-lg md:text-[22px] font-medium sm:text-xl text-[#212529]">
                    Fill Out For More Details
                  </h5>

                  <form className="space-y-3">
                    <input
                      type="text"
                      placeholder="Enter your Name*"
                      required
                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#f39731] sm:text-base"
                    />

                    <input
                      type="text"
                      placeholder="Enter your Company Name*"
                      required
                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#f39731] sm:text-base"
                    />

                    <input
                      type="text"
                      placeholder="Enter your Phone Number*"
                      required
                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#f39731] sm:text-base"
                    />

                    <input
                      type="email"
                      placeholder="Enter your Email ID*"
                      required
                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#f39731] sm:text-base"
                    />

                    <button
                      type="submit"
                      className="w-full rounded-md py-2 text-white transition hover:opacity-90"
                      style={{ background: "#f39731", border: "none" }}
                    >
                      Get in Touch
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
}

export default DriverSection1;